var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogInactive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8799A8",
    fillRule: "evenodd",
    d: "M10.366 14.325h4.268c.476 0 .866-.39.866-.866v-.268c0-.476-.39-.866-.866-.866h-4.268c-.477 0-.866.39-.866.866v.268c0 .476.39.866.866.866m8.134 4c0 .55-.448 1-1 1h-10c-.551 0-1-.45-1-1v-9h12v9zm-12-13h12c.552 0 1 .449 1 1 0 .55-.448 1-1 1h-12c-.551 0-1-.45-1-1 0-.551.449-1 1-1zm15 1c0-1.654-1.346-3-3-3h-12c-1.654 0-3 1.346-3 3 0 .883.391 1.67 1 2.22v9.78c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-9.78c.609-.55 1-1.337 1-2.22z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogInactive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/log_inactive.d765e675.svg";
export { ForwardRef as ReactComponent };